// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleOnClick() {

    this.closeUpdateStatusChangeModal();

}

const MachineUpdateModalHeader = props =>
    <header className='machine-update-modal-header'>
        <FormattedMessage
            id={`${props.machineStatusModalAction}_MACHINE_STATUS_UPDATE`}
        />
        <span
            className='close-modal-icon'
            onClick={props::handleOnClick}
        />
    </header>;

MachineUpdateModalHeader.displayName = 'MachineUpdateModalHeader';
MachineUpdateModalHeader.propTypes = {
    closeUpdateStatusChangeModal: PropTypes.func.isRequired,
    machineStatusModalAction: PropTypes.string.isRequired
};

export default MachineUpdateModalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/machine-update-modal-header.js